export const widgetView = [
    {
        label: 'Все участники',
        value: 'allMembers',
    },
    {
        label: 'Карусель',
        value: 'сarousel',
    },
];

export const widgetMemberInfo = [
    {
        label: 'Фамилия Имя Отчество',
        value: 'showFullname',
        bold: 'showFullnameBold',
    },
    {
        label: 'Организация',
        value: 'showOrganization',
        bold: 'showOrganizationBold',
    },
    {
        label: 'Регалии',
        value: 'showRegalia',
        bold: 'showRegaliaBold',
    },
    {
        label: 'Доп. признак',
        value: 'showRoles',
    },
]
